import { render, staticRenderFns } from "./AssignCategory.vue?vue&type=template&id=2c8859f3&"
import script from "./AssignCategory.vue?vue&type=script&lang=js&"
export * from "./AssignCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports